import React from 'react';
import "../../../turkish/investment/turkiyede-egitim/Egitim.css";
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import Header from "../../header/Header"; 

export default function Yatirim() {
    return (
        <div>
           <Header
               
                title="在土耳其的投资"
                icon={<LocalAtmIcon style={{fontSize: "x-large"}}/>}
            />
            
            <div className="row" style={{margin:"0%",padding:"1%"}}>
                    
                    
          
                    <div className="col-12" style={{marginLeft:"1%",marginRight:"1%"}}>
                            <p class="card-text1">土耳其的经济在2003年，2003年和2018年实现了创纪录的增长，而在全球第18大经济体中，土耳其也在2018年升至13个。 在未来几年中，预计将继续落后于土耳其的增长势头。 其余取决于土耳其的财政纪律，2002年公共债务的国内生产总值比率下降了70％，低于2018年的30％水平。izlen严格的财政纪律对土耳其的预算平衡产生了积极的影响，这种下降趋势是最近16年开放的</p>
                    </div>
 
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                            <h3 style={{color:"#A4203A"}}><LocalAtmIcon style={{fontSize:"x-large",color:"black"}}/> 战略位置</h3>
                            <p class="card-text1">​​​​​​​​​​​​​​​​​​​​​​​​​​​土耳其的东西方地位既有效又具有成本效益，主要市场的南北轴线之间形成了天然桥梁。 土耳其，欧洲在4小时的飞行半径内，中东和北非地区以及中亚的15亿总人口，可轻松进入价值24万亿美元的市场。 它可以轻松进入16个不同时区的市场，直至约克，而土耳其航空则飞往122个国家/地区的255个目的地。 跨国公司的生产越来越多，因为出口和管理中心比土耳其更喜欢。
                            </p>
                    </div>
 
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                            <h3 style={{color:"#A4203A"}}><LocalAtmIcon style={{fontSize:"x-large",color:"black"}}/> 合格且负担得起的劳动力</h3>
                            <p class="card-text1">土耳其有3270万人，是欧洲第三大劳动力大军，与年轻人相比，土耳其的年轻人口是该国劳动力增长的最重要因素，它为获得最高地位做出了贡献。 与欧盟国家相比，土耳其的劳动力增长也最快。 通过提供土耳其大学毕业生人数的增加，该国迅速增长的大学中的年轻人口和大量劳动力是为了确保技术工人的转换。
                         </p>
                         <ul className="card-list">
                                 <li>超过670万的高等教育学生</li>
                                 <li>每年大约有80万名大学毕业生</li>
                                 <li>世界一流的工程教育</li>
 
 ​
                         </ul>
                    </div>
 
                    <div className="col-lg-4 col-md-6 col-sm-6 col-12" >
                            <h3 style={{color:"#A4203A"}}><LocalAtmIcon style={{fontSize:"x-large",color:"black"}}/> 优势研发生态</h3>
                            <p class="card-text1" >土耳其政府的目标是将研发投资在公共预算总额中的份额提高到2％。 到2018年，这一份额已超过1％，预计在未来几年中将达到2％。 土耳其的大量研发激励措施，受过良好教育的技术工人队伍得到了许多在市场上开展业务并具有竞争优势的全球公司的支持。 所有这些要素融合在一起，提供了在土耳其发生的动态生态系统。 如今，超过100家领先的全球公司在土耳其享有竞争性的研发奖励，并受益于不断发展的生态系统​</p>
                    </div>
                  
                   
                    
              
 
        </div>
        </div>
    )
}
